import { isNil } from "lodash";
import { Navigate } from "react-router-dom";
import { useAppContext } from "../app/AppContextProvider";
interface AuthorizeProps {
    children: any,
    roles?: Array<"Admin" | "Contributor">
}

const AuthorizeScreen = (props: AuthorizeProps) => {


    let context = useAppContext();

    let redirectUrl = window.location.href.split("/");
    redirectUrl = redirectUrl.slice(3)

    if (!context.isAuthenticated)
        return <Navigate to={"/login?url=/" + redirectUrl.join("/")} />;

    if (!isNil(props.roles)) {
        if (!context.user?.isAdmin && props.roles.includes("Admin"))
            return <Navigate to="/" />

        if (!context.user?.isContributor && props.roles.includes("Contributor"))
            return <Navigate to="/" />
    }

    return props.children
}

export default AuthorizeScreen;